import { render, staticRenderFns } from "./final_book_shops_table.vue?vue&type=template&id=7baceb32&scoped=true&lang=pug&"
import script from "./final_book_shops_table.vue?vue&type=script&lang=js&"
export * from "./final_book_shops_table.vue?vue&type=script&lang=js&"
import style0 from "./final_book_shops_table.vue?vue&type=style&index=0&id=7baceb32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7baceb32",
  null
  
)

export default component.exports